import React, { Component } from 'react';
import Table from '../../../Table/Table';
import { withRouter } from 'react-router';
import ListItem from './ListItem/ListItem';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
    getRules as fetchRules,
    fetchUrl
} from './rulesActions';
import {
    getMerchants
} from '../../../MerchantManagement/merchantManagementEntity';
import { toggleModal } from '../../../Modal/modalActions';
import { EmvioButton } from '@nexio/emvio-form-components';
import './RoutingRules.scss';
import {
    getRules,
    getIsRulesLoading,
    getIsRulesLoaded,
    getRulesErrorMessage,
    getIsEditRulesSuccessful,
    getEditRulesErrorMessage
} from './rulesEntity';
import { toast } from 'react-toastify';
import { toastIfError } from '../../../../utils/toast';
import { getUsers } from '../../../UserManagement/userManagementEntity';
import { getUsers as fetchUsers } from '../../../UserManagement/userManagementActions';

export class RoutingRules extends Component {
    static propTypes = {
        isEditRulesSuccessful: PropTypes.bool,
        isRulesLoading: PropTypes.bool,
        isRulesLoaded: PropTypes.bool,
        editRulesErrorMessage: PropTypes.string,
        onEditRule: PropTypes.func,
        onNewRule: PropTypes.func,
        match: PropTypes.shape({
            isExact: PropTypes.bool,
            params: PropTypes.shape({
                encodedUserName: PropTypes.string
            }),
            path: PropTypes.string,
            url: PropTypes.string
        }),
        user: PropTypes.array,
        rules: PropTypes.array,
        merchants: PropTypes.array
    };

    constructor(props) {
        super(props);

        this.state = {
            needsRefetch: false,
            username: atob(this.props.match.params.encodedUserName)
        };

        this.defaultColumnsAndProps = [
            {
                accessor: 'merchant',
                defaultSortDesc: true,
                Cell: (props) => (this.getMerchantName(props.original.merchantId)),
                label: 'MERCHANT',
                className: ['cursor-pointer'],
                minWidth: 150,
                show: true,
                sortable: true
            },
            {
                accessor: 'merchantId',
                filterable: true,
                label: 'MERCHANT ID',
                className: ['cursor-pointer'],
                minWidth: 300,
                show: true,
                sortable: false
            },
            {
                accessor: 'currency',
                filterable: false,
                label: 'CURRENCY',
                className: ['cursor-pointer'],
                minWidth: 175,
                show: true,
                sortable: false
            },
            {
                accessor: 'ruleType',
                filterable: false,
                label: 'ROUTING RULE TYPE',
                className: ['cursor-pointer'],
                minWidth: 175,
                show: true,
                sortable: false
            }
        ];
    }

    componentDidMount() {
        if (!this.props.users) {
            this.props.onGetUsers();
        }
    }

    componentDidUpdate(previousProps) {
        toastIfError(previousProps, this.props, 'editRulesErrorMessage');
        if (doesPropExistAndHasItChanged(previousProps, this.props, 'isEditRulesSuccessful') && this.props.isEditRulesSuccessful) {
            this.props.onEditRule();
            this.refetchData();

            toast('Rule updated successfully!', { type: 'success' });
        }
    }

    getMerchantName(originalMerchantId) {
        const merchant = _.find(this.props.merchants, (n) => {
            return n.merchantId === originalMerchantId;
        });

        return _.get(merchant, 'name') || 'Multiple';
    }

    getUserMerchantIds = () => {
        let merchantIds = _.get(_.find(this.props.users, (user) => {
            return user.userName === this.state.username;
        }), 'accessRights.merchantIds');

        return Object.keys(merchantIds || {});
    };

    getPaymentMerchants = () => {
        return _.filter(this.props.merchants, (merchant) => {
            return _.includes(this.getUserMerchantIds(), merchant.merchantId);
        });
    };

    getUserRules = () => {
        return _.map(this.props.rules, (rule) => {
            return {
                merchantId: _.get(rule, 'merchantId') || 'Multiple',
                currency: _.get(rule, 'currency') || '',
                ruleType: this.getRuleType(rule),
                ruleName: this.getRuleName(rule),
                rule,
                key: `${rule.ruleType}-${rule.currency || rule.merchantId}-${JSON.stringify(rule.weights || rule.itemRule)}`
            };
        });
    };

    getCount = () => {
        return _.size(this.props.rules);
    };

    getRuleType = (rule) => {
        return _.startCase(_.toLower(_.get(rule, 'ruleType'))) || '';
    };

    getRuleName = (rule) => {
        if (_.get(rule, 'ruleType') === 'ITEM_RULE') {
            return 'Item Rule';
        } else {
            return 'Target Allocation by MID - ' + rule.currency;
        }
    };

    selectRule = (history, { rule }) => {
        const modalData = {
            username: this.state.username,
            rules: this.props.rules,
            rule
        };

        this.props.onEditRule(modalData);
    };

    resetNeedsRefetch = () => {
        this.setState({ needsRefetch: false });
    };

    refetchData = () => {
        this.setState({ needsRefetch: true });
    };

    render() {
        const newRuleModalData = {
            username: this.state.username,
            rules: this.props.rules,
            rule: null
        };

        const isButtonDisabled = !this.props.isRulesLoaded || _.isEmpty(this.getPaymentMerchants());

        return (
            <div className="emvio-routing-rules-table">
                <div className="header">
                    <div className="username">
                        {atob(this.props.match.params.encodedUserName)}
                    </div>
                    <EmvioButton
                        className={classNames('add-rule-button', {
                            disabled: isButtonDisabled
                        })}
                        invertColors
                        size="small"
                        fullWidth
                        shouldHaveTooltip={isButtonDisabled}
                        title="No configured merchant found"
                        onClick={() => this.props.onNewRule(newRuleModalData)}
                        disabled={isButtonDisabled}>
                        Add New Rule
                    </EmvioButton>
                </div>
                <Table
                    fetchUrl={fetchUrl}
                    className="rules-table"
                    defaultColumnsAndProps={this.defaultColumnsAndProps}
                    defaultSorted={[{
                        desc: false,
                        id: 'merchant'
                    }]}
                    fetchData={() => fetchRules(this.state.username)}
                    filterable={true}
                    dataSelector={this.getUserRules}
                    countSelector={this.getCount}
                    errorMessageSelector={getRulesErrorMessage}
                    isDataLoadingSelector={getIsRulesLoading}
                    pagesSelector={() => 1}
                    hasNoCount={true}
                    itemKey="key"
                    ListItemComponent={ListItem}
                    needsRefetch={this.state.needsRefetch}
                    noDataText="No Rules Found"
                    resetNeedsRefetch={this.resetNeedsRefetch}
                    selectRow={this.selectRule}
                    shouldAddColumnDialog={false}
                    shouldHideCardPadding
                    shouldHideDateRange
                    shouldHideExport
                    shouldHidePagination
                    uniqueTableName="Rules"
                />
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        users: getUsers(state),
        rules: getRules(state),
        isEditRulesSuccessful: getIsEditRulesSuccessful(state),
        isRulesLoading: getIsRulesLoading(state),
        isRulesLoaded: getIsRulesLoaded(state),
        editRulesErrorMessage: getEditRulesErrorMessage(state),
        merchants: getMerchants(state)
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        onEditRule: (modalData) => dispatch(toggleModal('editRule', modalData)),
        onNewRule: (modalData) => dispatch(toggleModal('editRule', modalData)),
        onGetUsers: () => dispatch(fetchUsers({}, 0, 100))
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RoutingRules));
